export class FiltroCliente {
    tipoDocumento: String;
    numeroDocumento: String;
    constructor(tipoDocumento: String, numeroDocumento: String) {
        this.tipoDocumento = tipoDocumento;
        this.numeroDocumento = numeroDocumento;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/filtro/filtro-cliente.ts